import React, { useState, useEffect } from 'react';
import { EditTwoTone } from '@ant-design/icons';
import { Drawer, Form, Input, Select, Button } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { updateRole } from '../../../redux/Roles/actions';
import { fetchCapabilities } from '../../../redux/Capabilities/actions';
import { fetchResources } from '../../../redux/resources/actions';

const layout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 },
};

export const EditRole = ({ item }) => {
  const dispatch = useDispatch();
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [form] = Form.useForm();
  const capabilities = useSelector((state) => state.capabilities.capabilities || []);
  const resources = useSelector((state) => state.resources.resources || []);

  useEffect(() => {
    dispatch(fetchCapabilities());
    dispatch(fetchResources());
  }, [dispatch]);

  const showDrawer = () => {
    onFill();
    setDrawerVisible(true);
  };

  const onFill = () => {
    form.setFieldsValue({
      ...item,
      defaultCapabilities: item.defaultCapabilities ? item.defaultCapabilities.map(capability => capability._id) : [],
      defaultRessources: item.defaultRessources ? item.defaultRessources.map(resource => resource._id) : [],
    });
  };

  const hideDrawer = () => {
    setDrawerVisible(false);
    form.resetFields();
  };

  const formOnFinish = (values) => {
    console.log(values)
    dispatch(updateRole(item._id, values));
    hideDrawer();
  };

  return (
    <>
      <EditTwoTone twoToneColor="blue" onClick={showDrawer} />
      <Drawer
        title="Edit Role"
        visible={drawerVisible}
        onClose={hideDrawer}
        width="70%"
        bodyStyle={{ padding: '16px', overflow: 'auto' }}
      >
        <Form
          {...layout}
          name="basic"
          form={form}
          onFinish={formOnFinish}
        >
          <Form.Item
            label="Role Name"
            name="name"
            rules={[{ required: true, message: 'Please enter the role name!' }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Default Capabilities"
            name="defaultCapabilities"
          >
            <Select
              mode="multiple"
              placeholder="Select default capabilities"
              options={capabilities.map(capability => ({
                label: capability.name,
                value: capability._id,
              }))}
            />
          </Form.Item>
          <Form.Item
            label="Default Ressources"
            name="defaultRessources"
          >
            <Select
              mode="multiple"
              placeholder="Select default resources"
              options={resources.map(resource => ({
                label: resource.name,
                value: resource._id,
              }))}
            />
          </Form.Item>
          <Form.Item wrapperCol={{ span: 24 }}>
            <Button type="primary" htmlType="submit" style={{ marginRight: 8 }}>
              Submit
            </Button>
            <Button onClick={hideDrawer}>Close</Button>
          </Form.Item>
        </Form>
      </Drawer>
    </>
  );
};

export default EditRole;
